var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"widget-content",domProps:{"innerHTML":_vm._s(_vm.props.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }